var map = {
	"./Bouddhanath/2.png": 9410,
	"./Bouddhanath/images.jpeg": 2613,
	"./Bouddhanath/sajan shrestha  MIT  Resume.pdf": 1784,
	"./JanakiTemple/images.png": 8365,
	"./Pashupathi/images.png": 5863,
	"./Pashupathi/sagar_shrestha_Resume (1).pdf": 6936,
	"./PatanDurbarSquare/EnglishDescription.txt": 923,
	"./PatanDurbarSquare/NewariDescription.txt": 6597,
	"./PatanDurbarSquare/image.png": 7536,
	"./bouddhanath.jpeg": 7670,
	"./janaki.jpeg": 8542,
	"./pashupati.jpeg": 4009,
	"./patandurbarsquare.png": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9849;